module.exports = "<div class=\"margin-md\">\r\n  <div class=\"kd-item padding-md\">\r\n    <div class=\"typo-subhead --text-light --text-bold\">Configuración de serie y folio por dirección</div>\r\n  </div>\r\n  <kd-repeater\r\n      list=\"$ctrl.data\">\r\n    <empresa-configuracion-facturacion-direcciones-item\r\n        ng-repeat=\"item in $items\"\r\n        empresa-id=\"$ctrl.empresaId\"\r\n        data=\"item\"></empresa-configuracion-facturacion-direcciones-item>\r\n  </kd-repeater>\r\n</div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/configuracion/facturacion/direcciones/template.html
// module id = 2476
// module chunks = 0